import axios from "axios";
import { logout } from "../lib/auth";
import { accountTableColumn } from "../config/account";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

export interface ProfileResponse {
  authority: string;
  account_name: string;
  plan_id: string | null;
  plan_name: string | null;
  max_partners: number | null;
  max_et_sites: number | null;
  has_payment: boolean | null;
  has_ai_analysis: boolean | null;
  current_partners: number;
  current_et_sites: number;
  monthly_price: number | null;
  [key: string]: string | number | boolean | null;
}

// 顧客詳細取得
export async function getProfile(): Promise<ProfileResponse> {
  try {
    const path = "profile";
    const response = await axios.get(CONST.apiUrl + path);
    const detail_data = response.data.detail_data[0] as ProfileResponse;
    return {
      ...detail_data,
      plan_id: response.data.plan_id ?? detail_data.plan_id ?? null,
      plan_name: response.data.plan_name ?? detail_data.plan_name ?? null,
      max_partners: response.data.max_partners ?? detail_data.max_partners ?? null,
      max_et_sites: response.data.max_et_sites ?? detail_data.max_et_sites ?? null,
      has_payment: response.data.has_payment ?? detail_data.has_payment ?? null,
      has_ai_analysis: response.data.has_ai_analysis ?? detail_data.has_ai_analysis ?? null,
      current_partners: response.data.current_partners ?? detail_data.current_partners ?? 0,
      current_et_sites: response.data.current_et_sites ?? detail_data.current_et_sites ?? 0,
      monthly_price: response.data.monthly_price ?? detail_data.monthly_price ?? null,
    };
  } catch (error) {
    return {} as ProfileResponse;
    // logout();
  }
}
